import { $elementChild, $elementChildren } from "@grindex-common/helpers/elements";

function init($views) {
	const ACTIVE_CLASS = "active";
	const MOBILE_WIDTH = 1024;
	const $view = $views[0];
	const $menuTrigger = $elementChild($view, "menu-trigger");
	const $submenuTriggers = $elementChildren($view, "sub-trigger");
	const $menuItems = $elementChildren($view, "menu-item");
	const $window = $(window);

	function toggleNavigation() {
		return window.innerWidth < MOBILE_WIDTH && $view.classList.toggle(ACTIVE_CLASS);
	}

	function triggerNavigation($link) {
		return () => {
			if ($link.href) {
				const url = new URL($link.href);

				if (url.hash && (url.path !== window.location.pathname || !window.path)) {
					$window.trigger("campaignNavigation", [url.hash]);
					toggleNavigation();
				}
			}
		};
	}

	$menuItems.forEach(($menuItem) => {
		$menuItem.querySelectorAll("a").forEach(($link) => {
			$link.addEventListener("click", triggerNavigation($link));
		});
	});

	$submenuTriggers.forEach(($link) => {
		$link.addEventListener("click", (event) => {
			if (window.innerWidth < MOBILE_WIDTH) {
				event.preventDefault();
			}

			$submenuTriggers.forEach(($trigger) => $trigger.parentElement.classList.remove(ACTIVE_CLASS));
			$link.parentElement.classList.add(ACTIVE_CLASS);
		});
	});

	$menuTrigger.addEventListener("click", toggleNavigation);

	window.addEventListener("load", () => {
		if (window.location) {
			$window.trigger("campaignNavigation", [window.location.hash]);
		}
	});
}

export default {
	view: "single-promotion-header",
	init,
};
